import { Component, OnInit } from '@angular/core';
declare var jQuery:any;

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.css']
})
export class CookiesComponent implements OnInit{

  constructor() { }

  ngOnInit(): void {
    this.showTermsCoookieAfterThreeMonth();
  }

  showTermsCoookieAfterThreeMonth(){
    if (localStorage.getItem('termo-aceito-em')) {
        var dataAceite = new Date(parseInt(localStorage.getItem('termo-aceito-em')));
        var timeDiff = Math.abs(dataAceite.getTime() - Date.now());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        if (diffDays <= 90) {
          document.getElementById("banner-cookie").style.display="none";
          document.getElementById("backTop").style.display="block";
        } else {
          document.getElementById("banner-cookie").style.display="block";
          document.getElementById("backTop").style.display="none";
        }
    } else {
      document.getElementById("banner-cookie").style.display="block";
    }
  }

  hideCookies(aceito: boolean){
    document.getElementById("banner-cookie").style.display="none";
    document.getElementById("backTop").style.display="block";
    if (aceito) {
    	localStorage.setItem('termo-aceito-em', Date.now().toString());
    }
  }
  showTermsCookies(){
    jQuery("#modalCookie").modal("show");
  }
}
